import React, { useContext } from 'react';
import PropTypes from 'prop-types';

export const CoreContext = React.createContext({});
export const useCore = () => useContext(CoreContext);

export const CoreProvider = ({ children, endpoints }) => (
  <CoreContext.Provider value={{ endpoints }}>{children}</CoreContext.Provider>
);
CoreProvider.defaultProps = { children: null, endpoints: {} };
CoreProvider.propTypes = {
  children: PropTypes.node,
  endpoints: PropTypes.object,
};
